import React from "react";
import { ProcessBase, ProcessState } from "types/process";

export interface DownloadActionResultOptions {
  /**
   * Human-friendly filename shown to the user
   */
  filename?: string | null;

  /**
   * Download status text set by the caller
   * e.g. "Download started — check browser downloads"
   */
  downloadStatus?: string | null;

  /**
   * Optional error message (used when processState === ERROR)
   */
  errorMessage?: string | null;
}

/**
 * Builds a standardized Result section for dialogs that initiate file downloads.
 *
 * Intended for use with ModalDialogConfirmStatusWithPolling buildResultSection.
 */
export function DownloadActionResult(
  process: ProcessBase,
  options: DownloadActionResultOptions
): React.ReactNode {
  const { filename, downloadStatus, errorMessage } = options;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {filename && (
        <div>
          <strong>File:</strong> {filename}
        </div>
      )}

      {process.processState === ProcessState.COMPLETE && (
        <div>
          <strong>Download:</strong>{" "}
          {downloadStatus || "Download started — check browser downloads."}
        </div>
      )}

      {process.processState === ProcessState.ERROR && (
        <div>
          <strong>Download:</strong> {errorMessage || "Download failed."}
        </div>
      )}
    </div>
  );
}
